import { ErrorBoundary } from 'react-error-boundary'
import { ErrorPage } from '@wellesley/error-kit'
import { KeepAliveOutlet } from './KeepAliveOutlet'

export const ErrorBoundaryLayout = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <KeepAliveOutlet limit={8} />
    </ErrorBoundary>
  )
}
